import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTripleDotsHorizontalLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M13.75 6.5q0 1.5-1.5 1.5h-.5q-1.5 0-1.5-1.5t1.5-1.5h.5q1.5 0 1.5 1.5M13.75 12q0 1.5-1.5 1.5h-.5q-1.5 0-1.5-1.5t1.5-1.5h.5q1.5 0 1.5 1.5M12.25 19q1.5 0 1.5-1.5t-1.5-1.5h-.5q-1.5 0-1.5 1.5t1.5 1.5z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTripleDotsHorizontalLine)
export default ForwardRef
